import { Chains } from './exchangeActiveChainUtils';

/**
 * This action is just to prepare UI for real change of chain
 * Comment out when there is need to use it,
 * but keep in mind it might cross-tab communication.
 */
// export const preChangeExchangeChain = (chain: Chains, reload = true) => ({
//   type: 'CHANGE_EXCHANGE_CHAIN' as const,
//   chain,
//   reload,
// });

/**
 * This gets set only once, then become static until next page reload.
 * It prevents Chains dropdown from displaying new chain before fully reloaded
 */
// let staticChain: Chains;

/**
 * TODO: katana return only single chain ?
 * We are keeping rest of state in LOCAL STORAGE only
 * Otherwise it would be problematic to initialize websocket early,
 * and also chain switch is slowed down by propagating state change
 */
export function getActiveChainFromState(): Chains {
  return 'katanaEVMChain';
  // if (process.env.NODE_ENV === 'test') {
  //   return 'katanaEVMChain';
  // }
  // Chain is immutable until refresh
  // if (staticChain) {
  //   return staticChain;
  // }
  //
  // const storedChain = localStorage.getItem(CHAIN_LOCAL_STORAGE_ID);
  //
  // if (storedChain) {
  //   // We need to migrate from Ethereum chain to Polygon, for all users
  //   // as this will be single chain for now.
  //   localStorage.removeItem(CHAIN_LOCAL_STORAGE_ID);
  // }

  // Hacky solution to change chain dynamically based on route
  // To apply chain chain properly it's required to reload page
  // staticChain = getStaticChainWithUrlExceptions();

  // if (
  //   initiallyEnforcedChainByURL &&
  //   initiallyEnforcedChainByURL.code !== storedChain
  // ) {
  //   staticChain = initiallyEnforcedChainByURL.code;
  //   initiallyEnforcedChainByURL = undefined;
  //   localStorage.setItem(CHAIN_LOCAL_STORAGE_ID, staticChain);
  // } else if (
  //   storedChain &&
  //   chainsList.some(chain => chain.code === storedChain)
  // ) {
  //   staticChain = storedChain as Chains;
  // } else {
  //   console.log('No stored chain found - fallback to ETH');
  //   staticChain = 'xchainEVMChain';
  // }

  // return staticChain;
}
